import { useState } from 'react';
import PageLayout from '../components/PageLayout';
import RegistrationForm from '../components/RegistrationForm';
import EventInfoCard from '../components/EventInfoCard';
import EventPicker from '../components/EventPicker';
import CrossSellPrompt from '../components/CrossSellPrompt';
import { getOpenRegistrationEvents } from '../config/events';

const RegistrationPage = () => {
  // Snapshot once per visit so the list doesn't shift under the user; the form
  // itself re-checks closesAt when they submit.
  const [openEvents] = useState(() => getOpenRegistrationEvents());
  // Skip the picker when only one event is live — same experience as before.
  const onlyEvent = openEvents.length === 1 ? openEvents[0] : null;
  const [selectedEvent, setSelectedEvent] = useState(onlyEvent);
  const [registered, setRegistered] = useState(null); // { formData, userId } once registration succeeds

  if (!selectedEvent) {
    return (
      <PageLayout>
        <EventPicker events={openEvents} onSelect={setSelectedEvent} />
      </PageLayout>
    );
  }

  const otherEvents = openEvents.filter((e) => e.id !== selectedEvent.id);
  // Only offer switching back while more than one event is live, and before they've registered
  // (once registered, CrossSellPrompt is the way to add other events).
  const canChangeEvent = openEvents.length > 1 && !registered;

  return (
    <PageLayout>
      {canChangeEvent && (
        <button type="button" className="change-event-link" onClick={() => setSelectedEvent(null)}>
          ← Choose a different event
        </button>
      )}
      <EventInfoCard event={selectedEvent} />
      {/* ADD THIS BLOCK: */}
      {/* <div className="event-banner-image-wrapper">
        <img
          src="/assets/womens-mar-2026.jpeg"    // match the filename you upload
          alt="March community event"       // describe the image
          className="event-banner-image"
        />
      </div> */}
      <RegistrationForm
        key={selectedEvent.id}
        event={selectedEvent}
        onRegistered={(formData, userId) => setRegistered({ formData, userId })}
      />
      {registered && otherEvents.length > 0 && (
        <CrossSellPrompt events={otherEvents} userId={registered.userId} formData={registered.formData} />
      )}
    </PageLayout>
  );
};

export default RegistrationPage;
